import { render, staticRenderFns } from "./AccountAvatar.vue?vue&type=template&id=71d88850&scoped=true"
import script from "./AccountAvatar.vue?vue&type=script&lang=js"
export * from "./AccountAvatar.vue?vue&type=script&lang=js"
import style0 from "./AccountAvatar.vue?vue&type=style&index=0&id=71d88850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d88850",
  null
  
)

export default component.exports